import angular from 'angular';

import FeedbackViewCtrl from './FeedbackViewCtrl';
import feedbackComponent from './feedbackComponent';
import indexUrl from './index.html';

const feedbackModule = angular.module('sling.dashboard.manage.feedback', []);

feedbackModule.config(($stateProvider) => {
  $stateProvider.state('dashboard.manage.feedback', {
    url: '/feedback',
    templateUrl: indexUrl,
    controller: FeedbackViewCtrl,
    controllerAs: 'ctrl',
    data: {
      title: 'Labor cost',
    },
  });
});

feedbackModule.component('feedback', feedbackComponent);

export default feedbackModule.name;
